<template>
  <el-select
  v-if="isManager"
    class="header-select-item"
    @change="handleFilter"
    v-model="listQuery.TenantId"
    filterable
    placeholder="选择商户"
    style="position: relative"
  >
    <el-option
      v-for="item in tenantOptions"
      :key="item.Id"
      :label="item.Name"
      :value="item.Id"
    ></el-option>
  </el-select>
</template>

<script>
import { setTenantId, setTenantName } from "@/utils/service";
export default {
  data() {
    return {
      listQuery: {
        Page: 1,
        PerPage: 1000,
        TenantId:""
      },
      // teantOptions: [],
    };
  },
  mounted() {
  },
  computed: {
    tenantOptions: function () {
      return this.$store.state.user ? this.$store.state.user.tenantList : [];
    },
    isManager:function(){
      return this.$store.state.user.isManager;
    },
    loginTenantId: function () {
      return this.$store.state.user.tenantId
    }
  },
  watch: {
    "$store.state.user.tenantId": function (newV) {
      this.listQuery.TenantId = newV;
    },
    "$store.state.user.tenantList": function (newV) {
      let arr = newV.filter(v => {return v.Id === this.loginTenantId});
      this.listQuery.TenantId = arr.length === 0 ? newV[0].Id : this.loginTenantId;
      this.handleFilter(this.listQuery.TenantId);
    },
  },
  methods: {
    handleFilter(val) {
      let data = this.tenantOptions.filter((item) => {
        return item.Id === val;
      });
      setTenantId(data[0].Id);
      setTenantName(data[0].Name);
      this.$store.dispatch("SetTenantId", data[0].Id);
    },
  },
};
</script>


<style lang="scss">
.header-select-item {
  & .el-input__inner {
    border: 0;
    background: #f3f3f3;
    opacity: 1;
    border-radius: 2px;
  }
}
</style>
